export default __webpack_public_path__ + "static/media/dashboard-alt-light.05d88514.png";